import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import PDSubscriptionCard from "../purpledoor/PDSubscriptionCard";
import PDSubscriptionDetails from "../purpledoor/PDSubscriptionDetails";

export default function PDMySubscriptions({ userId }) {
    const authState = useSelector((state) => state.authReducer);
    const [fetchData] = useFetch();
    const userCode = authState?.user?.think5whyscode || "";
    const token = authState?.token;
    const [rows, setRows] = useState([]);
    const [selected, setSelected] = useState(null);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);

    const [message, setMessage] = useState({ text: '', type: '' });
        
    const showMessage = (text, type = "success") => {
        setMessage({ text, type });
    };

    const [subscriptions, setSubscriptions] = useState([]);

    const fetchSubscriptions = async () => {
      setLoading(true);
      try {
          const config = {
              url: "/cfo/pd/subscription/light",
              method: "post",
              data: { userId },
              headers: { Authorization: authState.token },
          };
            const response = await fetchData(config, { silent: true });
          if (response?.status) {
              setSubscriptions(response?.data || []);
          }
      } catch (err) {
          console.error("❌ Onboarding fetch error:", err);
          showMessage("Failed to load subscription", "error");
      }

      setLoading(false);
    };
    
    useEffect(() => {
        if (userId) fetchSubscriptions();
    }, [userId]);
    
    const filtered = subscriptions.filter((r) => r.subscriptionId
            ?.toLowerCase()
            .includes(search.toLowerCase())
    );

    return (
        <div className="p-3">
            <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search Subscription ID..."
                className="w-full mb-3 p-2 text-xs bg-[#111827] border border-gray-700 rounded"
            />
            {loading && (
                <div className="text-xs text-gray-100">
                    Loading subscriptions...
                </div>
            )}

            {!loading && filtered.length === 0 && (
                <div className="text-xs text-gray-200">
                    No subscriptions found
                </div>
            )}

            {filtered.map((item, index) => (
                <>
                <PDSubscriptionCard
                    key={item._id}
                    data={item}
                    index={index}
                    onClick={() => setSelected(item)}
                />
                </>
            ))}
            {selected && (
                <PDSubscriptionDetails
                    data={selected}
                    onClose={() => setSelected(null)}
                />
            )}
            
        </div>
    );
}